
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ServiceCharacter, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class ServiceCharacterEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    serviceCharacter: ServiceCharacter;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getServiceCharacter()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getServiceCharacter(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.serviceCharacter = data;
                this.onDataChanged.next(this.serviceCharacter);
                resolve(this.serviceCharacter);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('serviceCharacter/' + this.routeParams.id).subscribe((res: ServiceCharacter ) => {
                    this.serviceCharacter = res;
                    this.onDataChanged.next(this.serviceCharacter);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(serviceCharacter): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('serviceCharacter/', serviceCharacter).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(serviceCharacter): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('serviceCharacter/', serviceCharacter).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(serviceCharacter): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('serviceCharacter/' + serviceCharacter.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): ServiceCharacter {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
